import { useLazyQuery } from '@apollo/client';

import GetPaginatedFieldVerificationsQuery from '@/graphql/contracts/getPaginatedFieldVerifications.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetPaginatedFieldVerifications,
  GetPaginatedFieldVerificationsVariables
} from '@/graphql/contracts/_generated_/getPaginatedFieldVerifications.query';
import { FIELD_VERIFICATIONS_PER_PAGE } from '@/config/common.config';

type GetPaginatedFieldVerificationsDto = Omit<GetPaginatedFieldVerificationsVariables, 'pageSize'>;

export function useGetPaginatedFieldVerifications() {
  const [_getFieldVerifications, { loading, data }] = useLazyQuery<
  GetPaginatedFieldVerifications,
  GetPaginatedFieldVerificationsVariables
  >(
    GetPaginatedFieldVerificationsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-and-network',
    }
  );

  const getFieldVerifications = (dto: GetPaginatedFieldVerificationsDto) => {
    _getFieldVerifications({
      variables: {
        pageSize: FIELD_VERIFICATIONS_PER_PAGE,
        ...dto,
      }
    });
  };

  return {
    getFieldVerifications,
    verificationsData: data?.paginatedFieldVerifications,
    isLoading: loading,
  } as const;
}
